import request from '@/utils/request2'

// 列表
export function listDictApi(data) {
  return request({
    url: 'tms-web/dict/list',
    method: 'post',
    data
  })
}
